<div class="custom-scroll-parent">
  <div
    class="results-menu-scroll custom-scroll lightblue-scrollbar-track gpx-16"
    [class.collapsed]="collapsed()"
    [ngClass]="{ 'gpt-32 gpb-72': mobile() }"
  >
    @if (dashboardLink.visible) {
      <app-card-nav-item
        class="d-block gmb-16"
        [class.collapsed]="collapsed()"
        [url]="dashboardLink.url"
        [icon]="dashboardLink.icon"
        [title]="dashboardLink.title"
        (clicked)="navItemClick(dashboardLink.dataTrack)"
      />
    }
    <p
      class="title l1-semibold text-ellipsis text-uppercase text-muted gpt-4 gpl-8 gpb-8 m-0 gmt-16 gmt-md-0"
    >
      <span>{{ 'RESULTS.MENU.ALL.DNA_INSIGHTS' | translate }}</span>
    </p>
    @for (item of dnaLinks; track item) {
      @if (item.visible) {
        <app-card-nav-item
          class="d-block gmb-8"
          [url]="item.url"
          [fragment]="item.fragment"
          [title]="item.title"
          [icon]="item.icon"
          [isNew]="item.new"
          [isNewAnalyses]="item.newAnalyses"
          [class.collapsed]="collapsed()"
          (clicked)="navItemClick(item.dataTrack)"
        />
      }
    }

    <div class="d-none d-md-block border-bottom gmt-8 w-100"></div>

    <p
      class="title l1-semibold text-ellipsis text-uppercase text-muted gpt-4 gpl-8 gpb-8 m-0 gmt-16 gmt-md-8"
    >
      <span class="collapsed-name" [class.collapsed]="collapsed()">
        {{ 'RESULTS.MENU.ALL.LIFESTYLE_INSIGHTS' | translate }}
      </span>
    </p>
    @for (item of lifestyleLinks; track item) {
      @if (item.visible) {
        <app-card-nav-item
          class="d-block gmb-8"
          [url]="item.url"
          [fragment]="item.fragment"
          [title]="item.title"
          [icon]="item.icon"
          [isNew]="item.new"
          [isNewAnalyses]="item.newAnalyses"
          [class.collapsed]="collapsed()"
          (clicked)="navItemClick(item.dataTrack)"
        />
      }
    }

    <div class="d-none d-md-block border-bottom gmt-8 w-100"></div>

    <p
      class="title l1-semibold text-ellipsis text-uppercase text-muted gpt-4 gpl-8 gpb-8 m-0 gmt-16 gmt-md-8"
    >
      <span class="collapsed-name" [class.collapsed]="collapsed()">
        {{ 'RESULTS.MENU.ALL.FEATURES' | translate }}
      </span>
    </p>
    @for (item of featureLinks; track item) {
      @if (item.visible) {
        <app-card-nav-item
          class="d-block gmb-8"
          [url]="item.url"
          [fragment]="item.fragment"
          [title]="item.title"
          [icon]="item.icon"
          [isNew]="item.new"
          [isNewAnalyses]="item.newAnalyses"
          [class.collapsed]="collapsed()"
          (clicked)="navItemClick(item.dataTrack)"
        />
      }
    }
  </div>
</div>
